import "./IndexLife.css";
import CriticalImg from "../SmcLife/Images/critical-illness.svg";

const CriticalIllness = () => {
    return (
        <div className="col-lg-7">
            <div className="critical_Illness">
                <div className="critical_life">
                    <h4 className="Index-Plan">
                        Comprehensive Term Insurance with <span className="textcolor"> Critical Illness </span>
                        Cover
                    </h4>
                    <p className="Index-Plan-Cont">
                        Protecting your family and you, no matter what life brings.
                    </p>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="critical_img">
                            <img
                                src={CriticalImg}
                                className="imgtop"
                                alt="Life Plan Image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CriticalIllness;
